
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M27.776 25.528h-.588c0 3.456-1.399 6.578-3.663 8.844a12.466 12.466 0 0 1-8.844 3.663 12.463 12.463 0 0 1-8.843-3.663 12.466 12.466 0 0 1-3.664-8.844c-.007-1.636.777-4.039 1.99-6.64 1.818-3.91 4.569-8.312 6.862-11.723A155.75 155.75 0 0 1 14.83 1.76c.207-.28.318-.43.32-.43l-.469-.355-.47.356s.202.265.559.751c1.247 1.698 4.371 6.054 7.175 10.758 1.401 2.352 2.722 4.79 3.686 7.015.966 2.221 1.562 4.243 1.557 5.673h1.176c-.007-1.98-.86-4.455-2.101-7.135C22.534 10.379 15.16.639 15.15.62L14.682 0l-.47.62c-.005.008-3.286 4.348-6.576 9.608-1.644 2.63-3.291 5.49-4.535 8.165-1.24 2.68-2.093 5.155-2.101 7.135 0 7.557 6.126 13.683 13.682 13.683 7.557 0 13.683-6.126 13.683-13.683h-.589z","stroke":"#000","stroke-width":".5"}}),_c('text',{attrs:{"font-family":"HyundaiSansHead, Hyundai Sans Head","font-size":"11","font-weight":"bold","transform":"translate(1)"}},[_c('tspan',{attrs:{"x":"7.021","y":"27"}},[_v('PB')])])])])
          )
        }
      }
    